import { Component, h, Prop } from "@stencil/core"

@Component({
  tag: "privacy-modal",
  styleUrls: ["./privacy-modal.css", "../../global/tailwind.min.css"],
  shadow: true,
})
export class PrivacyModal {
  @Prop() message: string
  @Prop() show: boolean
  // @Prop() linkText: string = "Click here to view the privacy policy"
  // @Prop() linkUrl: string = "https://ai12z.com/privacy-policy"
  // @Prop() linkTarget: string = "_blank"

  render() {
    if (!this.show) return null
    return (
      <div class="w-full">
        <div class="privacy-msg" innerHTML={this.message}></div>

        {/* <div class="flex gap-2 justify-center">
          <a href={this.linkUrl} target={this.linkTarget} class="link-privacy-modal hover:underline block text-center">
            {this.linkText}
          </a>
        </div> */}
      </div>
    )
  }
}
